import { fetchConfig, activate, getBoolean, getValue } from 'firebase/remote-config';
import { remoteConfig } from '../config/firebase';
import { Currency } from '../types/event.types';

export interface AppConfig {
  enableCharging: boolean;
}

/**
 * Obtener configuración de la app desde Firebase Remote Config
 */
export const getAppConfig = async (): Promise<AppConfig> => {
  try {
    await fetchConfig(remoteConfig).catch(err => {
      console.warn('Remote Config fetchConfig failed:', err);
    });
    await activate(remoteConfig).catch(err => {
      console.warn('Remote Config activate failed:', err);
    });

    return {
      enableCharging: getBoolean(remoteConfig, 'enable_charging'),
    };
  } catch (error) {
    console.error('Error obteniendo Remote Config:', error);
    return { enableCharging: false };
  }
};

export const getCurrencies = (): Currency[] => {
  try {
    const raw = getValue(remoteConfig, 'currencies').asString();
    if (raw) return JSON.parse(raw) as Currency[];
  } catch (e) {
    console.warn('getCurrencies failed:', e);
  }
  return [];
};